export default __webpack_public_path__ + "static/B0193-01afc4b014232dc3add130d4944c6ec6.png";